import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MediaCard from "./card";
const SliderImgs = ({ img_one, img_tow }) => {
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <div style={{ width: "250px" }}>
      <Slider {...settings}>
        <div>
            <img height='200px' width='300px' src={img_one} alt="filer" />
        </div>
        <div>
            <img height='200px' width='300px' src={img_tow} alt="filer" />
        </div>
      </Slider>
    </div>
  );
};

export default SliderImgs;
